module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticStyle: {
      "color": "#FF5555"
    }
  }, [_vm._v("  您不具备该操作权限！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca4c85e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/exclude/noPermission.vue
// module id = 1896
// module chunks = 502